import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
export interface Hip {
    id: number
    nombre: string
    ubicacion: string
    imagen: string
    disabled?: boolean
}
const HipodromoCard:React.FC<Hip>= ({id, nombre, ubicacion, imagen, disabled} ) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{ 
        width: '100%', 
        height: '100%', 
        cursor: disabled ? 'default' : 'pointer', 
        display: 'flex', 
        flexDirection: 'column',
        position: 'relative',
        opacity: disabled ? 0.8 : 1
      }}
      onClick={() => !disabled && navigate(`/hipodromo/${id}`)}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="140"
          width={140}
          image={imagen}
          alt={nombre}
          sx={{ filter: disabled ? 'grayscale(100%)' : 'none' }}
        />
        {disabled && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              bgcolor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography variant="h6" color="white" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
              Próximamente
            </Typography>
          </Box>
        )}
      </Box>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {nombre}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {ubicacion}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default HipodromoCard;